import React from 'react'
import ReactGA from 'react-ga'

import DocumentTitle from 'react-document-title'

import PropTypes from 'prop-types'
import { withStyles } from 'material-ui/styles'
import Card, { CardActions, CardContent, CardMedia } from 'material-ui/Card'
import Paper from 'material-ui/Paper'
import Button from 'material-ui/Button'
import Typography from 'material-ui/Typography'
import { CircularProgress } from 'material-ui/Progress'

import classNames from 'classnames'

import 'react-quill/dist/quill.core.css'
import 'react-quill/dist/quill.snow.css'

import globalConfig from './ControlPanel/config'
import ajax from './ControlPanel/utils/ajax'
import MyImage from './Image'
import CBlock from './block'

import Styles from '../styles/Styles'
import '../styles/Quill.scss'

class TopicPage extends React.Component {
    constructor(props) {
        super(props)
        const { domain, alias } = props
        this.state = {
            domain,
            alias,
            summary: {},
            blocks: [],
            tryingLogin: true,
        }
    }

    async componentWillMount() {
        ReactGA.pageview(window.location.pathname + window.location.search)
        const { match, beforeAll, beforeAllFunc } = this.props
        const alias = this.state.alias
        const domain = this.state.domain
        let summary = await ajax.CRUD('topic').select({
            domain,
            alias,
        })

        if (!summary.success) {
            this.setState({
                summary: {
                    text: "not found",
                },
                tryingLogin: false,
            })
            return
        }

        this.setState({
            summary: summary.data,
        })
        // console.log("data:", summary)
        const data = await ajax.get(`${globalConfig.getAPIPath()}/post-block/select`, {
            params: {
                id: summary.data.id,
            },
        })
        // console.log("details,", data)
        // data.data.map((item, id) => {
        //     console.log(item.id)
        // })
        this.setState({
            blocks: data.data,
            tryingLogin: false,
        })
    }
    renderBlock(block, i) {
        const { classes } = this.props
        const { title, authors, text } = block
        const authorsElems = null
        const authorList = []
        if (authors && authors.length > 0) {
            // authorsElems = <div className="TextShadow" style={{ 'paddingLeft': '1%' }}>
            //     {/* <Typography component="strong">Authors:</Typography> */}
            //     {/* <ul style={{ 'paddingLeft': '3%' }}>{[...authors.map((a, i) => <li key={i}>{a}</li>)]}</ul> */}
            //     {authors.join(", ")}
            // </div>
            Object.keys(authors).forEach((item, ix) => {
                const name = authors[item]
                const idx = ix * 2
                if (ix === 0) {
                    // name
                    authorList.push((<span key={idx} >{name}</span>))
                } else if (i < (authors.length - 1)) {
                    // , name
                    authorList.push((<span key={idx} >, </span>))
                    authorList.push((<span key={idx + 1} >{name}</span>))
                    // return (<div><span>,</span> <span key={i} >{name}</span></div>)
                } else {
                    // and name
                    authorList.push((<span key={idx} > and </span>))
                    authorList.push((<span key={idx + 1} >{name}</span>))
                }
            })
        }

        return (<div key={i} style={{ paddingBottom: '10px' }}>
            <Card className={classes.card}>
                <CardContent>
                    <Typography variant="headline" component="h2">
                        {title || ''}
                    </Typography>
                </CardContent>
                <Typography variant="subheading" style={{ paddingLeft: '3%', paddingRight: '3%' }}>
                    {/* {authorsElems} */}
                    {[...authorList]}
                </Typography>
                <CardContent>
                    <Typography component="p">
                        <span dangerouslySetInnerHTML={{ __html: text }} style={{ display: 'inline' }} />
                    </Typography>
                </CardContent>
            </Card>
        </div>)
    }

    render() {
        const { classes, match } = this.props

        // console.log("classes %o, match: %o", classes, match)

        const { title, image, summary, text } = this.state.summary
        const docTitle = `${title || 'Topic'} | SunLab`
        // let tldr = null
        // if (summary) {
        //     tldr = <Alert style={{ 'margin': '1em' }} message={summary} />
        // }
        let featuredImage = null
        if (image) {
            featuredImage = (<CardMedia
                className="ResearchFeatureImage"
                image={image} />)
        }
        return (<div className="Quill">
            <DocumentTitle title={docTitle} />
            {/* <h1 style={{ 'padding': '0.5em', 'lineHeight': '1.2em' }} >{title || ""}</h1>
            <hr style={{ 'margin': '0.5em' }} />
            {featuredImage}
            <div dangerouslySetInnerHTML={{ __html: text }} style={{ 'display': 'inline' }} /> */}

            <div style={{ padding: '10px' }}>
                <div className={classNames(classes.card)}>
                    <CardContent>
                        <Typography variant="headline" component="h1" style={{ textAlign: 'center' }}>
                            {title || ''}
                        </Typography>
                    </CardContent>

                    <div>
                        {featuredImage}
                        <div dangerouslySetInnerHTML={{ __html: text }} style={{ display: 'inline' }} />
                    </div>

                </div>
            </div>


            <div className="clearfix" />

            {/* Sections... */}

            {[...this.state.blocks.map((b, i) => <CBlock key={i} block={b} id={i} />)]}

            {
                this.state.tryingLogin
                    ? <div className="Center"><CircularProgress className={classes.progress} size={80} /></div>
                    : null
            }
        </div>)
    }
}

TopicPage.propTypes = {
    classes: PropTypes.object.isRequired,
}

export default withStyles(Styles)(TopicPage)
